var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-warning"},[_c('img',{staticClass:"title-warning-icon",attrs:{"src":"https://image.xiaomaiketang.com/xm/44H3yrMZb8.png"}}),_vm._v("\n  "+_vm._s(_vm.titleWarning)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }